import { Mutation } from 'vuex';
import { IModuleState } from './types';

// 列表
export const setDigitalRooms: Mutation<IModuleState> = (state, payload) => {
  state.list.data = payload.data;
  state.list.pageNum = payload.pageNum;
  state.list.pageSize = payload.pageSize;
  state.list.total = payload.total;
  state.list.loading = !!payload.loading;
};

// 普通弹窗
export const setDialog: Mutation<IModuleState> = (state, payload) => {
  state.dialog.type = payload.type;
  state.dialog.data = payload.data || null;
  state.dialog.visible = !!payload.visible;
  state.dialog.loading = !!payload.loading;
};

// 确认弹窗
export const setConfirm: Mutation<IModuleState> = (state, payload) => {
  state.confirm.type = payload.type;
  state.confirm.title = payload.title;
  state.confirm.content = payload.content;
  state.confirm.visible = !!payload.visible;
  state.confirm.loading = !!payload.loading;
};

export const setSearch: Mutation<IModuleState> = (state, payload) => {
  state.search = payload;
};

export const setLoading: Mutation<IModuleState> = (state, payload) => {
  state.loading = !!payload;
};
